import { createAction, props } from "@ngrx/store";
import { CalendarioPublicacoesOutputDto } from "src/app/domain/DTOs/output/calendario-publicacoes.output.dto";
import { EstruturaRetornoDadosOutputDto } from "src/app/domain/DTOs/output/estrutura-retorno-dados.output.dto";

const actionName = "[ ObterCalendarioPublicacao ] Obter calendario publicacao";

export const obterCalendarioPublicacao = createAction(
  actionName,
  props<{ inputDto: number}>()
);

export const obterCalendarioPublicacaoSuccess = createAction(
  `${actionName} - Sucesso`,
  props<{ response: EstruturaRetornoDadosOutputDto<CalendarioPublicacoesOutputDto> }>()
);

export const obterCalendarioPublicacaoFailure = createAction(
  `${actionName} - Falha`,
  props<{ response: EstruturaRetornoDadosOutputDto<CalendarioPublicacoesOutputDto> }>()
);

export const obterCalendarioPublicacaoFinish = createAction(
  `${actionName} - Concluir`
);
